<template>
  <div class="area">
    <div class="title">{{ title }}</div>
    <SiruiSearch :query="meterDetail" :columns="formColumn" :isQueryPanel="false"></SiruiSearch>
    <el-divider></el-divider>
  </div>
</template>
<script>
  import MeterAPI from '@/api/property/meterManagement';
  import {
    formColumn as baseFormColumns,
    lineColumn,
    regionColumn,
  } from './meterInformationCard.js';
  export default {
    name: 'MeterInformationCard',
    props: {
      // 入参
      showMeterData: {
        type: Object,
        default: () => {},
      },
    },
    // 当前组件需要用的数据 data computed 局部变量 类 函数
    data() {
      return {
        meterDetail: {},
        title: '', //标题
        spaceNameList: [],
        smartFlagList: [
          {
            value: 0,
            label: '否',
          },
          {
            value: 1,
            label: '是',
          },
        ],
      };
    },
    computed: {
      formColumn() {
        let columnList = [];
        if (this.showMeterData.type == '1') {
          columnList = baseFormColumns(this);
        } else if (this.showMeterData.type == '2' || this.showMeterData.type == '3') {
          columnList = lineColumn(this);
        } else {
          columnList = regionColumn(this);
        }
        return columnList;
      },
    },
    // mounted 简单可能就是几行代码
    mounted() {
      this.getDetail();
      this.settingTitle();
      this.getArea();
    },
    // 当组件的方法,可能比较多
    methods: {
      // 页面展示标题
      settingTitle() {
        const meterType = {
          1: '变压器总表信息',
          2: '线路总表信息',
          3: '区域总表信息',
        };
        this.title = meterType[this.showMeterData.type] || '区域子表信息';
      },
      // 电表详情
      async getDetail() {
        const { data } = await this.$axios.get(
          `${MeterAPI.ELECTRIC_METER}/${'' + this.showMeterData.id}`
        );
        if (data.code == 0) {
          this.meterDetail = data.data.electricMeter || {};
          console.log('详情', this.meterDetail);
          this.meterDetail.smartFlag = data.data.electricMeter.smartFlag.toString();
          if (this.meterDetail.selfUseFlag != null) {
            this.meterDetail.selfUseFlag = data.data.electricMeter.selfUseFlag.toString();
          }
          if (this.meterDetail.virtualTableFlag != null) {
            this.meterDetail.virtualTableFlag = data.data.electricMeter.virtualTableFlag.toString();
          }
          if (this.meterDetail.inductanceRatio != null) {
            this.meterDetail.inductanceRatio = data.data.electricMeter.inductanceRatio.toString();
          }
          if (this.meterDetail.loss != null) {
            this.meterDetail.loss = data.data.electricMeter.loss.toString();
          }
          if (this.meterDetail.meterReadingWarning != null) {
            this.meterDetail.meterReadingWarning =
              data.data.electricMeter.meterReadingWarning.toString();
          }
        }
      },
      // 获取片区数据
      async getArea() {
        console.log('获取片区');
        const { data } = await this.$axios.get(MeterAPI.GET_AREA, { companyNo: this.companyCode });
        if (data.code == 0) {
          this.spaceNameList = data.data;
        }
      },
    },
    watch: {
      showMeterData: {
        handler: function (newVal) {
          console.log('树状结构改变了', newVal);
          if (newVal.id != null) {
            this.getDetail();
            this.settingTitle();
          }
        },
        deep: true,
      },
    },
    components: {},
  };
</script>
<style scoped lang="scss">
  .area {
    margin-left: 20px;
    margin-top: 15px;
    background-color: white;
    width: 100%;
    .title {
      font-size: 20px;
      color: black;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: bolder;
    }
  }
</style>
